import { motion } from "framer-motion";
import { SITE } from "@/lib/site";

const words = SITE.brands.map((b) => b.name + (b.sub ? " " + b.sub : ""));

function TextRow({ items, reverse = false, duration = 34, className = "" }) {
  const line = items.join("   ✦   ");
  return (
    <div className="overflow-hidden">
      <motion.div
        className="flex whitespace-nowrap will-change-transform"
        initial={{ x: reverse ? "-50%" : "0%" }}
        animate={{ x: reverse ? "0%" : "-50%" }}
        transition={{
          repeat: Infinity,
          repeatType: "loop",
          duration,
          ease: "linear",
        }}
      >
        <span className={`shrink-0 pr-12 ${className}`}>{line}</span>
        <span className={`shrink-0 pr-12 ${className}`} aria-hidden>
          {line}
        </span>
      </motion.div>
    </div>
  );
}

export default function EditorialMarquee() {
  return (
    <section
      id="brands"
      data-testid="brand-marquee"
      className="relative py-16 md:py-24 overflow-hidden"
    >
      <div className="relative">
        {/* Fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-48 bg-gradient-to-r from-[#0d1117] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-48 bg-gradient-to-l from-[#0d1117] to-transparent z-10" />

        {/* Row 1 — big editorial text row, all 13 names cycling left */}
        <TextRow
          items={words}
          duration={34}
          className="font-display font-extrabold text-[9vw] md:text-[5.5vw] leading-none text-white/85 tracking-tighter py-3"
        />

        {/* Row 2 — italic cyan gradient text cycling right (opposite direction) */}
        <div className="mt-4">
          <TextRow
            items={[...words].reverse()}
            reverse
            duration={30}
            className="font-display italic text-[6vw] md:text-[3.6vw] leading-none text-grad-brand tracking-tighter py-2"
          />
        </div>
      </div>
    </section>
  );
}

